<template>
  <div class="d-flex align-items-center">
    <span>
      <b class="mr-1">Payment Method:</b>
    </span>
    <span>{{ paymentMethod }}</span>
    <div v-if="expired"><b>(Expired)</b></div>
    <i
      v-if="!paymentNotEnabled"
      class="ml-1 link far fa-pen-to-square"
      @click="toggleModal"
    ></i>
    <PaymentMethodModal
      v-if="editPaymentMethod"
      :customer="customer"
      @hide-modal="toggleModal"
      @save-success="$emit('save-success')"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

import PaymentMethodModal from "./PaymentMethodModal.vue";

export default {
  components: {
    PaymentMethodModal
  },
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  emits: ["save-success"],
  data() {
    return {
      editPaymentMethod: false,
      methodType: "card"
    };
  },
  computed: {
    ...mapState({
      gpiEnabled: ({ paymentMethods }) => {
        return paymentMethods.some((method) => method.key === "gpi_card");
      },
      staxEnabled: ({ paymentMethods }) => {
        return paymentMethods.some((method) => method.key === "stax_card");
      },
      ccEnabled: ({ paymentMethods }) => {
        return paymentMethods.some((method) =>
          ["gpi_card", "stax_card"].includes(method.key)
        );
      },
      achEnabled: ({ paymentMethods }) => {
        return paymentMethods.some((method) =>
          ["gpi_ach", "stax_ach"].includes(method.key)
        );
      },
      gpiAchEnabled: ({ paymentMethods }) => {
        return paymentMethods.some((method) => method.key === "gpi_ach");
      },
      staxAchEnabled: ({ paymentMethods }) => {
        return paymentMethods.some((method) => method.key === "stax_ach");
      }
    }),
    paymentMethod() {
      if (this.paymentNotEnabled) {
        return "Not Enabled";
      }
      if (!this.customer.payment_method) {
        return "Not Available";
      }
      if (this.customer.payment_method.payment_type === "card") {
        const { last4, brand } = this.customer.payment_method;
        return `${brand} ...${last4}`;
      }
      if (this.customer.payment_method.payment_type === "ach") {
        const { last4, ach_account_type } = this.customer.payment_method;
        return `${this.capitalize(ach_account_type)} ACH ...${last4}`;
      }
      return "--";
    },
    expired() {
      return (
        this.customer.payment_method && this.customer.payment_method.expired
      );
    },
    paymentNotEnabled() {
      return !this.ccEnabled && !this.achEnabled;
    }
  },
  methods: {
    toggleModal() {
      this.editPaymentMethod = !this.editPaymentMethod;
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-divider {
  border-bottom: 1px solid var(--gray-border-color);
  width: 100%;
  margin: 2px 0;
}
</style>
